<template>
  <div style="height: 100%">
    <Row style="height: 100%;">
      <Col span="12">
        <div style="display: flex; align-items: center;height: 100%">
          <div style="font-size: 14px" @click="changeIsCollapse " v-if="$store.state.settingItem.foldButton === true">
            <i class="el-icon-menu"  style="margin: 0 15px" ></i>
          </div>
          <div style="width: 10px" v-if="$store.state.settingItem.foldButton === false">
          </div>
          <Breadcrumb style="margin-left:5px">
            <BreadcrumbItem>信息管理</BreadcrumbItem>
            <BreadcrumbItem>
              <span style="color: #606266;font-weight: bold">
                {{ currentPathName }}
              </span>
            </BreadcrumbItem>
          </Breadcrumb>
        </div>
      </Col>
      <Col span="12">
        <div style="float: right;display: flex;justify-content: center;">
<!--          <div style="margin-top: 13px">-->
<!--            <marquee direction="left" style="width: 300px;"><span style="color: #F56C6C;">库存内存在材料数量预警，请及时查看！</span></marquee>-->
<!--          </div>-->
          <div style="margin-top: 12px">
            <el-tooltip class="item" effect="dark" content="全屏 / 取消全屏" placement="bottom">
          <span style="color: #606266;margin-left: 20px;">
            <i class="el-icon-full-screen" style="font-weight: bold" @click="handleFullScreen"></i>
          </span>
            </el-tooltip>

            <el-tooltip class="item" effect="dark" content="所在科室" placement="bottom">
          <span style="color: #606266;margin-left: 20px;">
            <el-tag type="primary">{{user.room}}</el-tag>
          </span>
            </el-tooltip>
            <el-dropdown style="width:auto; cursor: pointer; text-align: right;margin-left: 20px;margin-right: 20px">
              <div style="display: inline-block">
                <span style="font-size: 15px;color: #606266">{{ user.realName }}（</span>
                <span style="font-size: 15px;color: #606266">{{ user.username }}）</span>
                <i class="el-icon-arrow-down" style="margin-left: 5px;color: #606266"></i>
              </div>
              <el-dropdown-menu slot="dropdown" style="width: 100px; text-align: center">
                <el-dropdown-item style="font-size: 14px; padding: 5px 0">
                  <span style="text-decoration: none" @click="logout">退出</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <i class="el-icon-s-operation" style="margin-right: 20px" @click="setting"></i>
          </div>

<!--          <div id="he-plugin-simple" style="margin-top: 0"></div>-->
        </div>

      </Col>
    </Row>
    <Drawer v-model="settingDrawer">
      <Divider>
        <span style="font-size: 13px; color: #808695">主题风格设置</span>
      </Divider>
      <Row>
        <Col span="8">
          <img src="../assets/bg1.svg" alt="" @click="settingChangeImg1('bg1')">
          <br>
          <Badge status="success" style="margin-left: 25px; padding: 0" v-if="settingImgShow1 === 'bg1'"/>
        </Col>
        <Col span="8">
          <img src="../assets/bg2.svg" alt="" @click="settingChangeImg1('bg2')">
          <br>
          <Badge status="success" style="margin-left: 25px; padding: 0" v-if="settingImgShow1 === 'bg2'"/>
        </Col>
      </Row>
      <br>
      <Row>
        <Col span="8">
          <img src="../assets/bg3.svg" alt="" @click="settingChangeImg2('bg3')">
          <br>
          <Badge status="success" style="margin-left: 25px; padding: 0" v-if="settingImgShow2 === 'bg3'"/>
        </Col>
        <Col span="8">
          <img src="../assets/bg4.svg" alt="" @click="settingChangeImg2('bg4')">
          <br>
          <Badge status="success" style="margin-left: 25px; padding: 0" v-if="settingImgShow2 === 'bg4'"/>
        </Col>
        <Col span="8">
          <img src="../assets/bg5.svg" alt="" @click="settingChangeImg2('bg5')">
          <br>
          <Badge status="success" style="margin-left: 25px; padding: 0" v-if="settingImgShow2 === 'bg5'"/>
        </Col>
      </Row>
      <Divider>
        <span style="font-size: 13px; color: #808695">导航设置</span>
      </Divider>
      <Form :model="$store.state.settingItem" :label-width="195" label-position="left">
        <FormItem label="侧边栏开启手风琴模式">
          <i-switch v-model="$store.state.settingItem.accordion" size="small" @on-change="changeSetting('accordion')"></i-switch>
        </FormItem>
        <FormItem label="显示折叠侧边栏按钮">
          <i-switch v-model="$store.state.settingItem.foldButton" size="small" @on-change="changeSetting('foldButton')"></i-switch>
        </FormItem>
      </Form>
    </Drawer>
  </div>
</template>

<script>
import {mapMutations} from "vuex";

export default {
  name: "Header",
  watch:{
    $route(to,from)  {
      this.currentPathName = localStorage.getItem("currentPathName")
      console.log('from',from)
      console.log('to',to)
      let form = {}
      form = {
        path:to.fullPath,
        name:to.meta.title
      }
      this.$store.state.activeTabs = form.path
      this.$store.state.fromPath = from.fullPath
      console.log('把这个item推到pathUrlList中',form)

      this.getPathUrl(form)
      if (to.fullPath === '/home'){
        return 0
      }else {
        if (!this.$store.state.pathUrlList.some(item => JSON.stringify(item) === JSON.stringify(form))) {
          this.$store.state.pathUrlList.push(form);
          console.log(this.$store.state.pathUrlList)
        }
      }
      console.log("列表",this.$store.state.pathUrlList)
    }
  },

  data(){
    return{
      currentPathName:'',
      user:localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
      fullscreen:false,
      tableData:[],
      settingDrawer:false,
      settingImgShow1:'bg1',
      settingImgShow2:'bg3',
      phone:'',
      formItem:{},
      defaultPack:true
    }

  },
  created() {
    // this.load()

    // window.WIDGET = {
    //   "CONFIG": {
    //     "modules": "01234",
    //     "background": "1",
    //     "tmpColor": "fff",
    //     "tmpSize": "14",
    //     "cityColor": "fff",
    //     "citySize": "14",
    //     "aqiColor": "fff",
    //     "aqiSize": "14",
    //     "weatherIconSize": "21",
    //     "alertIconSize": "14",
    //     "padding": "18px 10px 10px 10px",
    //     "shadow": "0",
    //     "language": "auto",
    //     "fixed": "false",
    //     "vertical": "top",
    //     "horizontal": "left",
    //     "city": "CN101121005",
    //     "key": "9d5b6ccaa2f94f82a328153b9aea11ac"
    //   }
    // };
    // (function (d) {
    //   var c = d.createElement('link')
    //   c.rel = 'stylesheet'
    //   c.href = 'https://widget.heweather.net/simple/static/css/he-simple.css?v=1.4.0'
    //   var s = d.createElement('script')
    //   s.src = 'https://widget.heweather.net/simple/static/js/he-simple.js?v=1.4.0'
    //   var sn = d.getElementsByTagName('script')[0]
    //   sn.parentNode.insertBefore(c, sn)
    //   sn.parentNode.insertBefore(s, sn)
    // })(document)
  },

  methods:{
    ...mapMutations({getPathUrl:'PATH_URL',FROM_PATH:'FROM_PATH'}),
    logout() {
      localStorage.setItem("user", {})
      this.$router.push("/login")
      this.$message.success("退出成功")

    },
    load(){
      this.request.get("http://60.205.56.25:8080/api/material_page",{
        params:{
          pageNum:1,
          pageSize:10,
          materialWarn:"1"
        }
      }).then(res =>{
        this.tableData = res.records

      })
      setTimeout(() => {
        this.load();
      },30000)
    },
    handleFullScreen(){
      if (this.fullscreen){
        if (document.exitFullscreen()){
          document.exitFullscreen();
        }else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }else if (document.mozCancelFullScreen){
          document.mozCancelFullScreen
        }else if (document.msExitFullScreen){
          document.msExitFullScreen
        }

      }else {
        let element=document.documentElement
        if (element.requestFullscreen){
          element.requestFullscreen()
        }else if (element.webkitRequestFullScreen){
          element.webkitRequestFullScreen()
        }else if (element.mozRequestFullScreen){
          element.mozRequestFullScreen()
        }else if (element.msRequestFullScreen){
          element.msRequestFullScreen()
        }
      }
      this.fullscreen=!this.fullscreen
    },
    changeIsCollapse(){
      console.log(11111)
      this.isCollapse = !this.isCollapse
      this.$bus.$emit('isCollapse',this.isCollapse)
    },
    setting(){
      this.settingDrawer = true
    },
    settingChangeImg1(val){
      this.settingImgShow1 = val
      if (val === 'bg1'){
        this.$store.state.asideColor = '#191a23'
        this.$store.state.asideTextColor = '#ffffff'
      }else {
        this.$store.state.asideColor = '#fcfcfc'
        this.$store.state.asideTextColor = '#17233d'
      }
    },
    settingChangeImg2(val){
      this.settingImgShow2 = val
      if (val === 'bg3'){
        this.$store.state.headerColor = '#fcfcfc'
      }else if(val === 'bg4') {
        this.$store.state.headerColor = '#191a23'
      }else{
        this.$store.state.headerColor = '#2d8cf0'
      }
    },
    changeSetting(val){
      if (val === 'accordion'){
        this.$store.state.settingItem.accordion = !$store.state.settingItem.accordion
      }
      if (val === 'foldButton'){
        this.$store.state.settingItem.foldButton = !$store.state.settingItem.foldButton
      }
    }
  }
}
</script>

<style scoped>

</style>
